import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { SourceHttpClient } from './source-http.client';
import { SourceActions } from './source.store';

@Injectable({ providedIn: 'root' })
export class SourceEffects {
  private readonly sourceHttpClient = inject(SourceHttpClient);
  private readonly actions$ = inject(Actions);

  public effect = createEffectFactory(SourceActions, this.actions$);

  public fetchSources$ = this.effect(SourceActions.fetchCollection, () =>
    this.sourceHttpClient.fetch().pipe(map(sources => ({ data: sources }))),
  );
}
